import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

/* COMPONENTS */
import Navbar from './components/Navbar';
import Footer from './components/footer';
import FloatingActions from './components/FloatingActions';
import PageLoader from './components/PageLoader';
import CookieBanner from './components/CookieBanner';

/* SECTIONS */
import Home from './pages/home';
import Products from './pages/products';
import Services from './pages/services';
import Contact from './pages/contact';
import SupplyRange from './pages/SupplyRange';

function App() {
  const [loading, setLoading] = useState(true);
  const [productOpen, setProductOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">

      {loading && <PageLoader />}

      {!loading && (
        <>
          <Navbar />

          <main>

            {!productOpen && (
              <>
                <Home />
              </>
            )}

            <Products setProductOpen={setProductOpen} />

            {!productOpen && (
              <>
                <SupplyRange />
                <Services />
                <Contact />
              </>
            )}

          </main>

          <Footer />
          <FloatingActions />
          <CookieBanner />
        </>
      )}

    </div>
  );
}

export default App;